module.exports = __webpack_public_path__ + "img/42c07c3.jpg";